import Header from './components/Header';
import Footer from './components/Footer';
import ClickSpark from './components/ClickSparks';
import { Outlet, ScrollRestoration } from 'react-router-dom';

function App() {
  return (
    <ClickSpark
      sparkColor="#ffffff"
      sparkSize={10}
      sparkRadius={15}
      sparkCount={8}
      duration={400}
    >
      <ScrollRestoration />
      <Header />

      <main>
        <Outlet />
      </main>

      <Footer />
    </ClickSpark>
  );
}

export default App;